const parser = document.createElement('a');

const components = [
  'protocol', 'hostname', 'port', 'pathname', 'search', 'hash',
];

const defaultPorts = {
  'http:': '80',
  'https:': '443',
  'ftp:': '21',
  'sftp:': '22',
};

function removeDefaultPort(url, protocol) {
  return url.replace(new RegExp(`:${defaultPorts[protocol]}(/|$)`), '$1');
}

export const ERRORS = {
  invalidURL: '[URL] Could not parse url',
  invalidPort: '[URL] Port should be a convertible to Number value',
};

export function parseUrl(url) {
  parser.href = url;

  return _.pick(parser, components);
}


export default class URL {
  constructor(url, options = {}) {
    const { skipValidation = false } = options;

    const parts = parseUrl(url);

    _.forEach(parts, (value, key) => {
      this[key] = value;
    });

    if (!skipValidation && removeDefaultPort(url, this.protocol) !== this.href) {
      throw new Error(ERRORS.invalidURL);
    }
  }

  _map = {};

  get protocol() {
    return this._map.protocol;
  }

  set protocol(val) {
    if (_.isNil(val) || val === '') {
      this._map.protocol = '';
    } else {
      this._map.protocol = _.includes(val, ':') ? val : `${val}:`;
    }
  }

  get domain() {
    return this._map.hostname;
  }

  set domain(val) {
    if (_.isNil(val) || val === '') {
      this._map.hostname = '';
    } else if (_.isArray(val)) {
      this._map.hostname = val.join('.');
    } else {
      this._map.hostname = `${val}`;
    }
  }

  get hostname() {
    return this.domain;
  }

  set hostname(val) {
    this.domain = val;
  }

  get port() {
    const { port } = this._map;
    const protocol = this.protocol;

    if (port === defaultPorts[protocol]) {
      return '';
    }

    return port;
  }

  set port(val) {
    if (_.isNil(val) || val === '') {
      this._map.port = '';
    } else {
      if (!/^\d+$/.test(val)) {
        throw new Error(ERRORS.invalidPort);
      }
      this._map.port = String(val);
    }
  }

  get path() {
    return this._map.pathname;
  }

  set path(val) {
    if (_.isNil(val) || val === '') {
      this._map.pathname = '';
    } else if (_.isArray(val)) {
      this._map.pathname = `/${val.join('/')}`;
    } else {
      this._map.pathname = _.startsWith(val, '/') ? String(val) : `/${val}`;
    }
  }

  get pathname() {
    return this.path;
  }

  set pathname(val) {
    this.path = val;
  }

  get search() {
    return this._map.search;
  }

  set search(val) {
    if (_.isNil(val) || val === '') {
      this._map.search = '';
    } else if (_.isString(val) && val.length) {
      this._map.search = _.includes(val, '?') ? val : `?${val}`;
    } else if (_.isNumber(val)) {
      this._map.search = `?${val}`;
    } else {
      const keys = _.keys(val);

      if (keys.length) {
        this._map.search = `?${_.map(keys, key => `${encodeURIComponent(key)}=${encodeURIComponent(val[key])}`).join('&')}`;
      } else {
        this._map.search = '';
      }
    }
  }

  get hash() {
    return this._map.hash;
  }

  set hash(val) {
    if (_.isNil(val) || val === '') {
      this._map.hash = '';
    } else {
      this._map.hash = _.includes(val, '#') ? val : `#${val}`;
    }
  }

  get filename() {
    return this.path.split('/').pop();
  }

  set filename(val) {
    const pathArray = this.path.split('/').slice(1, -1);

    if (!(_.isNil(val) || val === '')) {
      pathArray.push(val);
    }

    this.path = pathArray;
  }

  get href() {
    const port = this.port ? `:${this.port}` : '';

    return `${this.protocol}//${this.domain}${port}${this.path}${this.search}${this.hash}`;
  }

  toString() {
    return this.href;
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils/url/index.js